import React from 'react';
import Filter, { FilterModal, FilterSection } from './Filter';
import ButtonFilter from './FilterComponents/CoreComponents/ButtonFilter';
import { LeagueSessionTypes, sessionTypes } from '../../../utils/constants';

import styles from '../search.scss';

const LeagueTypeFilter = (props) => {
    const { filters, filterModal, handleFilterClick, closeModals, filterInputs, handleFilterUpdate, mobileOnly, desktopOnly, 'data-testid': dataTestId } = props;
    const { LeagueSessionType } = filters;

    return (
        <div className={styles.filterWrapper}>
            <Filter
                filterName={'type'}
                handleFilterClick={handleFilterClick}
                isActive={(filters && LeagueSessionType) || filterModal === 'type'}
                mobileOnly={mobileOnly}
                desktopOnly={desktopOnly}
                data-testid={dataTestId}
            >
                {filters && LeagueSessionType ? `${sessionTypes[LeagueSessionType]?.description}` : 'Type'}
            </Filter>
            {filterModal === 'type' && (
                <FilterModal
                    title={'Type'}
                    onCloseClick={closeModals}
                    data-testid={dataTestId}
                >
                    <FilterSection>
                        <ButtonFilter
                            options={[
                                { label: 'All', value: 0, colLength: 3 },
                                { label: 'Team Tournament', value: LeagueSessionTypes.TEAM_TOURNAMENT, colLength: 5 },
                                { label: 'Multi-Round', value: LeagueSessionTypes.MULTI_ROUND, colLength: 4 },
                            ]}
                            selected={filterInputs.LeagueSessionType}
                            onClick={(type) => {
                                handleFilterUpdate({ type }, 'submit');
                            }}
                            data-testid={dataTestId && `${dataTestId}.options`}
                        />

                    </FilterSection>
                </FilterModal>
            )}
        </div>
    );
};

export default LeagueTypeFilter;
